import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n';
import LegalLanguageMenu from './LegalLanguageMenu';

const content = {
  it: {
    kicker: 'Contatti',
    title: 'Contatti e richieste dati',
    intro: 'Per privacy, diritti GDPR e richieste sui dati puoi contattarci via email.',
    emailLabel: 'Email privacy',
    emailCopy: 'Usa questo indirizzo per accesso ai dati, rettifica, cancellazione, portabilita, opposizione o revoca del consenso.',
    response: 'Rispondiamo alle richieste privacy nei tempi previsti dalla normativa applicabile.',
    copyrightLabel: 'Copyright e rimozione contenuti',
    copyrightCopy: 'Se sei titolare dei diritti su una foto, un video o un post mostrato in Outfit Detective e vuoi chiederne la rimozione, scrivici indicando il link del contenuto e una prova semplice della titolarita.',
    copyrightResponse: 'Gestiamo le richieste di rimozione in modo rapido. I contenuti social restano di proprieta dei rispettivi titolari.',
    back: "Torna all'app",
  },
  en: {
    kicker: 'Contact',
    title: 'Contact and data requests',
    intro: 'For privacy, GDPR rights, and data requests, you can contact us by email.',
    emailLabel: 'Privacy email',
    emailCopy: 'Use this address for data access, rectification, deletion, portability, objection, or consent withdrawal.',
    response: 'We respond to privacy requests within the timelines required by applicable law.',
    copyrightLabel: 'Copyright and content removal',
    copyrightCopy: 'If you own rights in a photo, video, or post shown in Outfit Detective and want it removed, email us with the content link and simple proof of ownership.',
    copyrightResponse: 'We handle removal requests quickly. Social content remains owned by its respective rights holders.',
    back: 'Back to the app',
  },
  de: {
    kicker: 'Kontakt',
    title: 'Kontakt und Datenanfragen',
    intro: 'Für Datenschutz, DSGVO-Rechte und Datenanfragen kannst du uns per E-Mail kontaktieren.',
    emailLabel: 'Datenschutz-E-Mail',
    emailCopy: 'Nutze diese Adresse für Datenzugang, Berichtigung, Löschung, Portabilität, Widerspruch oder Widerruf der Einwilligung.',
    response: 'Wir beantworten Datenschutzanfragen innerhalb der gesetzlich vorgesehenen Fristen.',
    copyrightLabel: 'Copyright und Entfernung von Inhalten',
    copyrightCopy: 'Wenn du Rechte an einem Foto, Video oder Post hast, der in Outfit Detective gezeigt wird, und eine Entfernung wuenschst, schreibe uns mit dem Link und einem einfachen Nachweis.',
    copyrightResponse: 'Wir bearbeiten Entfernungsanfragen schnell. Social Content bleibt Eigentum der jeweiligen Rechteinhaber.',
    back: 'Zurück zur App',
  },
  fr: {
    kicker: 'Contact',
    title: 'Contact et demandes de données',
    intro: 'Pour la confidentialité, les droits RGPD et les demandes de données, vous pouvez nous contacter par e-mail.',
    emailLabel: 'E-mail confidentialité',
    emailCopy: "Utilisez cette adresse pour l'accès aux données, la rectification, la suppression, la portabilité, l'opposition ou le retrait du consentement.",
    response: 'Nous répondons aux demandes de confidentialité dans les délais prévus par la réglementation applicable.',
    copyrightLabel: 'Copyright et retrait de contenu',
    copyrightCopy: 'Si vous détenez des droits sur une photo, vidéo ou publication affichée dans Outfit Detective et souhaitez son retrait, écrivez-nous avec le lien du contenu et une preuve simple.',
    copyrightResponse: 'Nous traitons rapidement les demandes de retrait. Les contenus sociaux restent la propriété de leurs titulaires respectifs.',
    back: "Retour à l'app",
  },
  ro: {
    kicker: 'Contact',
    title: 'Contact si solicitari privind datele',
    intro: 'Pentru confidentialitate, drepturi GDPR si solicitari privind datele, ne poti contacta prin email.',
    emailLabel: 'Email privacy',
    emailCopy: 'Foloseste aceasta adresa pentru acces la date, rectificare, stergere, portabilitate, opozitie sau retragerea consimtamantului.',
    response: 'Raspundem solicitarilor de confidentialitate in termenele prevazute de legislatia aplicabila.',
    copyrightLabel: 'Copyright si eliminare continut',
    copyrightCopy: 'Daca detii drepturi asupra unei fotografii, unui video sau unei postari afisate in Outfit Detective si vrei eliminarea, scrie-ne cu linkul continutului si o dovada simpla.',
    copyrightResponse: 'Gestionam rapid solicitarile de eliminare. Continutul social ramane proprietatea titularilor respectivi.',
    back: 'Inapoi la app',
  },
  es: {
    kicker: 'Contacto',
    title: 'Contacto y solicitudes de datos',
    intro: 'Para privacidad, derechos RGPD y solicitudes de datos, puedes contactarnos por email.',
    emailLabel: 'Email de privacidad',
    emailCopy: 'Usa esta dirección para acceso a datos, rectificación, eliminación, portabilidad, oposición o retirada del consentimiento.',
    response: 'Respondemos a las solicitudes de privacidad dentro de los plazos previstos por la normativa aplicable.',
    copyrightLabel: 'Copyright y retirada de contenido',
    copyrightCopy: 'Si tienes derechos sobre una foto, video o post mostrado en Outfit Detective y quieres retirarlo, escríbenos con el enlace del contenido y una prueba sencilla.',
    copyrightResponse: 'Gestionamos las solicitudes de retirada con rapidez. El contenido social sigue perteneciendo a sus respectivos titulares.',
    back: 'Volver a la app',
  },
};

function ContactContent({ c }) {
  return (
    <main className="ct-legal-main">
      <article className="ct-legal-doc">
        <div className="ct-legal-head">
          <p className="ct-legal-kicker">{c.kicker}</p>
          <h1>{c.title}</h1>
          <p className="ct-legal-intro-text">{c.intro}</p>
        </div>

        <section className="ct-legal-section">
          <h2>{c.emailLabel}</h2>
          <p>
            <a href="mailto:privacy@outfitdetective.com">privacy@outfitdetective.com</a>
          </p>
          <p>{c.emailCopy}</p>
          <p>{c.response}</p>
        </section>

        <section className="ct-legal-section">
          <h2>{c.copyrightLabel}</h2>
          <p>
            <a href="mailto:privacy@outfitdetective.com?subject=Copyright%20removal%20request">privacy@outfitdetective.com</a>
          </p>
          <p>{c.copyrightCopy}</p>
          <p>{c.copyrightResponse}</p>
        </section>
      </article>
    </main>
  );
}

export default function Contact({ compact = false }) {
  const { language } = useI18n();
  const C = content[language] || content.en;

  if (compact) {
    return <ContactContent c={C} />;
  }

  return (
    <main className="ct-legal-page">
      <header className="ct-legal-header">
        <Link to="/" className="ct-legal-brand">
          <span className="ct-brand-mark image">
            <img src="/brand/outfit-detective-mark-transparent.svg" alt="" />
          </span>
          <span>Outfit Detective</span>
        </Link>
        <LegalLanguageMenu />
      </header>
      <ContactContent c={C} />

      <footer className="ct-legal-index-footer">
        <Link to="/">{C.back}</Link>
      </footer>
    </main>
  );
}
